import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TokenInterceptor } from "@app/login/token.interceptor";
import { CsrfInterceptor } from "@app/interceptors/csrf.interceptor";
import { BrowserModule } from "@angular/platform-browser";
/* Full calender connector and plugin */
/* End */
import { NgModule, ErrorHandler, inject, provideAppInitializer } from "@angular/core";
import {
  JwtModule,
  JwtHelperService,
  JwtModuleOptions,
} from "@auth0/angular-jwt";
import { CookieService } from "ngx-cookie-service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SignatureService } from "@services/signature.service";
import { CalendarIntegrationService } from "@services/calendar-integration.service";

// Routing
import { routing } from './app.routing';

// Components
import { AppComponent } from "./main/app.component";
import { LoginComponent } from "./login/login.component";
import { AuthService } from "./login/auth.service";
import { AuthGuard } from "./login/auth.guard";
import { MainService } from "./main.service";
import { DomainConfigComponent } from "./domain-config.component";
import { SharedService } from "./shared_service";
import { IsSecureGuard } from "./shared/is-secure.guard";
import { IntroComponent } from "./intro/intro.component";
import { ChangePasswordComponent } from "./dialogs/change-password/change-password.component";
import { ServiceModalChangePasswordComponent } from '@app/inp-services/service-modal-change-password/service-modal-change-password.component';
import { RecoverPasswordDialogComponent } from "./dialogs/recover-password-dialog/recover-password-dialog.component";
import { RecoverPasswordService } from "./dialogs/recover-password-dialog/recover-password.service";

// Import SHARE
import { SharedModule } from './trackvision/shared/shared.module';
import { NgxPermissionsModule } from "ngx-permissions";
import { BlockTemplateComponent } from '@layout/blockui/block-template.component';
import { BlockUIModule } from 'ng-block-ui';

import { NgbdDatepickerI18nComponent } from "./util/ngbd-datepicker-i18n/ngbd-datepicker-i18n.component";
import { AssignedLawyerDialogComponent } from "./dialogs/assigned-lawyer-dialog/assigned-lawyer-dialog.component";

import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { PoweredByComponent } from './_layout/powered-by/powered-by.component';
import { SetupAccountComponent } from './setup-account/setup-account.component';
import { ForceChangePasswordComponent } from './force-change-password/force-change-password.component';
import { LinkOAuthDialogComponent } from './dialogs/link-oauth-dialog/link-oauth-dialog.component';
import { MicrosoftCallbackComponent } from './microsoft-callback/microsoft-callback.component';
import { GoogleCallbackComponent } from './google-callback/google-callback.component';
import { CenteredMenuBtnComponent } from '@flows/shared/centered-menu-btn/centered-menu-btn.component';
import { HeaderNavComponent } from './_layout/header-nav/header-nav.component';
import { RouterModule } from '@angular/router';
import { DialogInfoComponent } from "./dialogs/dialog-info/dialog-info.component";
import * as Sentry from '@sentry/angular';
import { MarkdownModule } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
// Importar quill-mention con autoregister - esto registra automáticamente tanto el blot como el módulo
// La versión 6.1.1 tiene un sistema de autoregistro que funciona con Quill 2.0
import 'quill-mention/autoregister';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-CL';

import { loadUsetifulScript } from 'usetiful-sdk';

loadUsetifulScript('36692cdc92cb94e36dc5c78e49e06747');

// Registra la localización para Chile
registerLocaleData(localeEs);

// Config Sentry (Fase 1) — DSN vacío = fail-soft, sin envío
export function sentryErrorHandlerFactory() {
  return Sentry.createErrorHandler({ showDialog: false });
}
// End Config Sentry

export function gettoken() {
  return localStorage.getItem("access_token");
}

const jwtConf: JwtModuleOptions = {
  config: {
    tokenGetter: gettoken,
    allowedDomains: ["localhost:3001", "calendar-api.inprovider.com"],
  },
};

@NgModule({ declarations: [
        AppComponent,
        PublicLayoutComponent,
        PrivateLayoutComponent,
        PoweredByComponent,
        CenteredMenuBtnComponent,
        HeaderNavComponent,
        LoginComponent,
        IntroComponent,
        ChangePasswordComponent,
        RecoverPasswordDialogComponent,
        ServiceModalChangePasswordComponent,
        NgbdDatepickerI18nComponent,
        AssignedLawyerDialogComponent,
        BlockTemplateComponent,
        DialogInfoComponent,
        SetupAccountComponent,
        ForceChangePasswordComponent,
        LinkOAuthDialogComponent,
        MicrosoftCallbackComponent,
        GoogleCallbackComponent,
    ],
    bootstrap: [AppComponent],
    exports: [RouterModule, CenteredMenuBtnComponent, ServiceModalChangePasswordComponent, NgxPermissionsModule], imports: [BrowserModule,
        routing,
        JwtModule.forRoot(jwtConf),
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
        BlockUIModule.forRoot({
            template: BlockTemplateComponent
        }),
        MarkdownModule.forRoot(),
        NgxPermissionsModule.forRoot(),
        QuillModule.forRoot({
            suppressGlobalRegisterWarning: true
        })], providers: [
        DomainConfigComponent,
        provideAppInitializer(() => {
        const initializerFn = ((config: DomainConfigComponent) => () => config.load())(inject(DomainConfigComponent));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CsrfInterceptor,
            multi: true,
        },
        { provide: ErrorHandler, useFactory: sentryErrorHandlerFactory },
        AuthService,
        JwtHelperService,
        CookieService,
        AuthGuard,
        MainService,
        SharedService,
        IsSecureGuard,
        RecoverPasswordService,
        SignatureService,
        CalendarIntegrationService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
